import React from 'react';
import { Link } from 'react-router-dom';
import ReactStars from "react-rating-stars-component";

function SearchResult({ results }) {
    function truncateTitle(bookTitles) {
        if (bookTitles.length > 20) {
            return bookTitles.substring(0, 20) + "...";
        } else {
            return bookTitles;
        }
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10 mb-9">
            {results.map(book => (
                book.cover_i && (
                    <Link to={`/detail/${book.cover_edition_key}`} key={book.key} className="flex flex-col justify-center sm:w-auto">
                        <div className="card rounded-2xl overflow-hidden shadow-lg transition hover:transform hover:scale-90 duration-700 h-full">
                            <img className="object-cover h-60 mx-auto" src={`http://covers.openlibrary.org/b/id/${book.cover_i}-M.jpg`} alt={book.title} />
                            <div className="px-6 py-4">
                                <p className="font-bold text-lg mb-2">{truncateTitle(book.title)}</p>
                                <p className="text-base">{book.author_name}</p>
                                {book.ratings_sortable ? (
                                    <ReactStars count={5} value={book.ratings_sortable} size={24} activeColor="#ffd700" isHalf={true} edit={false}/>
                                ) : (
                                    <p>Aucune note</p>
                                )}
                            </div>
                            <div className="px-6 pt-4 pb-2">
                                <span className="card-date inline-block rounded-full px-3 py-1 text-sm font-semibold mr-2 mb-2">
                                    {book.first_publish_year ? book.first_publish_year : '???'}
                                </span>
                            </div>
                        </div>
                    </Link>
                )
            ))}
        </div>
    );
}

export default SearchResult;